import React from 'react';

/**
 * Card — the base surface: white, hairline border, soft shadow.
 * Optional title/subtitle header and action slot.
 */
export function Card({ title, subtitle, action, padding = 20, children, style = {}, ...rest }) {
  const hasHeader = title || subtitle || action;
  return (
    <div
      style={{
        background: 'var(--surface-card)', border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-sm)', overflow: 'hidden',
        ...style,
      }}
      {...rest}
    >
      {hasHeader && (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: `16px ${padding}px`, borderBottom: '1px solid var(--border-subtle)' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {title && <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-lg)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)', letterSpacing: 'var(--ls-heading)' }}>{title}</span>}
            {subtitle && <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--text-muted)' }}>{subtitle}</span>}
          </div>
          {action}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
    </div>
  );
}
